import React from 'react'

import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { Button, IconButton, Tooltip } from '@mui/material'
import { useWeeklyReportCreditsReset } from 'features/customers/hooks/useWeeklyReportCreditsReset'

type Props = { compact?: boolean }

const CustomerBomboraCompaniesUsageResetButton = ({ compact }: Props) => {
  const { mutate: resetUsage } = useWeeklyReportCreditsReset()

  if (compact) {
    return (
      <Tooltip title="Reset this month's Bombora usage">
        <IconButton aria-label="Reset Bombora usage" onClick={() => resetUsage()} size="small">
          <RestartAltIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )
  }

  return (
    <Button color="primary" onClick={() => resetUsage()}>
      Reset usage
    </Button>
  )
}

export default CustomerBomboraCompaniesUsageResetButton
